import { Loader } from '@crehana/compass.ui/v3/loader';

const Loading = () => (
  <div className="tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-pointer-events-none">
    <Loader />
  </div>
);

export default Loading;
